<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { interactionMixin } from "src/modules/interactions_module.js";
import { Youtube } from 'src/modules/youtube_module.js'
import { pick, get } from "lodash";
import Flickity from "flickity";
import "magnific-popup";
import "magnific-popup/dist/magnific-popup.css";

const getDurationTime = (val) => {
  if (typeof val === "number") {
    return val;
  } else if(typeof val === "string") {
    return parseInt(val.replace(/\D/g, ""));
  } else {
    return 0;
  }
};

export default {
  data: function() {
    return {
    };
  },
  mixins: [fandomBasicMixin, interactionMixin],
  mounted() {
    Vue.nextTick(() => {
      const procedure = $(this.$refs["procedure"]);
      if (procedure.length != 0) {
        procedure.magnificPopup({type: "image", delegate: ".magnific-popup"});
      }
      if (Fandom.exists(this.content.accessories)) {
        const carousel = new Flickity(this.$refs["accessory-carousel"], {
          draggable: ">1",
          prevNextButtons: false,
          pageDots: false,
          cellAlign: "left",
          wrapAround: false,
          freeSCroll: false,
          contain: true,
        });
      }
    });
    if (window.fandom_analytics_type == 'google_tag_manager') {
      this.sendAnalytics();
    }
  },
  methods: {
    getDurationTime,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getContentResponsiveImage: Fandom.getContentResponsiveImage,
    toggleYoutubePopup: Youtube.toggleYoutubePopup,
    capitalize: Fandom.capitalize,
    calcIngedients(field) {
      let ingredients = [];
      const recipeIngredients = field || [];
      for (let i = 0; i < recipeIngredients.length; i++) {
        let ingredient = {quantity: null, title: null};
        if (recipeIngredients[i]["quantity"]) {
          ingredient.quantity = recipeIngredients[i]["quantity"];
        }
        ingredient.title = this.getContent(recipeIngredients[i]["ingredient"]) ? this.getContent(recipeIngredients[i]["ingredient"]).title : recipeIngredients[i]["ingredient"];
        ingredients.push(ingredient);
      }
      return ingredients;
    },
    getIngredintsTitle(customTitle) {
      if(Fandom.exists(customTitle)) {
        return customTitle;
      } else {
        return this.ingredients_title_info;
      }
    },
    getTagsInfoFromContents(field, info = "title") {
      const fieldAr = field || [];
      const arrayConverter = content => Fandom.exists(content) ? pick(content, info) : false;
      const baseConverter = content => Fandom.exists(content) ? content[info] : false;
      const converter = Array.isArray(info) ? arrayConverter : baseConverter;
      return fieldAr.map(this.getContent).map(converter);
    },
    sendAnalytics() {
      let needs = this.content.special_occasions.filter((el) => {
        return el.startsWith('esigenza-');
      });

      let recipeOwner = this.content.owned_by;
      let recipeCourse = String(this.content.course);
      let recipeNeeds = String(needs);

      window.dataLayer.push({
        'event': 'recipeView',
        'recipeOwner': recipeOwner,
        'recipeCourse': recipeCourse,
        'recipeNeeds': recipeNeeds
      });
    }
  },
  computed: {
    color() {
      return get(this, ["content", "color"], "red-cabbage");
    },
    backgroundColorClass() {
      return `bg-${this.color}`;
    },
    borderColorClass() {
      return `border-${this.color}`;
    },
    textColorClass() {
      return `text-${this.color}`;
    },
    favourite() {
      return (this.content.interactions && this.content.interactions["favourite"]) ? this.content.interactions["favourite"] : false;
    },
    share() {
      return (this.content.interactions && this.content.interactions["share"]) ? this.content.interactions["share"] : false;
    },
    like() {
      return (this.content.interactions && this.content.interactions["like"]) ? this.content.interactions["like"] : false ;
    },
    owner() {
      if (Fandom.exists(this.content.owned_by) && this.pageModel.id_to_user[this.content.owned_by]) {
        return this.pageModel.id_to_user[this.content.owned_by];
      } else {
        return this.pageModel.anonymous_user;
      }
    },
    info() {
      return get(this, "content.info", false);
    },
    difficulty() {
      if(this.info && this.info.difficulty) {
        let difficultyTagName = this.info.difficulty;
        if(this.getContent(difficultyTagName)) {
          return this.getContent(difficultyTagName).title;
        }
      }
      return false;
    },
    ingredientsBoxes() {
      const primaryBox = {
        ingredients: this.content.ingredients,
        allergens: this.content.allergens,
        title: this.content.ingredients_title
      };
      const secondaryBox = {
        ingredients: this.content.secondary_ingredients,
        allergens: this.content.secondary_allergens,
        title: this.content.secondary_ingredients_title
      };
      const additionalBoxes = get(this, ["content", "ingredient_boxes"], []);
      return [primaryBox, secondaryBox].concat(additionalBoxes).filter(box => Fandom.exists(box.ingredients));
    },
    accessories() {
      return this.getTagsInfoFromContents(this.content.accessories, ["slug","thumbnail","title", "url"]);
    },
    specialOccasions() {
      return this.getTagsInfoFromContents(this.content.special_occasions,["slug","title"]);
    },
    expence() {
      if(this.info && this.info.expence) {
        let expenceTagName = this.info.expence;
        if(this.getContent(expenceTagName)) {
          return this.getContent(expenceTagName).title;
        }
      }
      return false;
    },
    imageUrl() {
      let url = this.getContentResponsiveImage("image");
      return url.replace("/original/", "/medium/");
    },
    totalTime() {

      const timeRecord = pick(this.content.time, ["cooking_time", "resting_time", "preparation_time"]);
      const reducer = (acc, val) => (+acc) + getDurationTime(val);
      return Object.values(timeRecord).reduce(reducer, 0);
    },
    ingredients_title_info(){
      let title = this.ft("recipe.ingredients");
      if(this.info.quantity) {
        title += this.ft("recipe.ingredients_for", {servings: this.info.quantity});
      }
      return title;
    },
    isYoutubePresent() {
      return get(this.content, ["play", "media_type"], false) === "youtube";
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :id="`ref-${easyadminId}`" :class="contentType" :style="{ '--recipe-color': `var(--${color})` }" recipe >
    <!-- <script type="application/ld+json" v-html="getSchemaData()"></script> -->
    <div class="container pt-4 pb-3">
      <div class="row justify-content-center">
        <div class="col-12 px-0">
          <breadcrumb class="px-0"></breadcrumb>
        </div>
        <div class="recipe__main-image col-12 col-lg-8 col-xl-7 pl-lg-0 order-1">
          <!-- <div v-if="content.image" class="main-img bg-cover-center" :style="{'background-image': getBackgroundUrl(content.image.url, 'medium')}"></div> -->
          <div v-if="content.image" class="main-img">
            <img :src="imageUrl" class="recipe-main-image" :title="content.title" :alt="content.title" />
            <embed-youtube class="position-absolute-center" :content="content" :opt-container-content="containerContent" v-if="isYoutubePresent"></embed-youtube>
          </div>
          <div v-else class="recipe-main-image ar-16by9 bg-kenwood-light-grey">
          </div>
        </div>
        <div class="recipe__info col-12 col-lg-4 col-xl-5 pt-4 pt-lg-0 order-2">
          <div class="row pl-3">
            <div class="recipe__info__favourite d-flex align-items-center col-12 pb-2 pl-0 border-bottom" v-if="favourite">
              <i class="fa-bookmark pr-2" :class="[isFavourite(containerContent, favourite.interaction) ? `fas ${textColorClass}` : 'fal']" @click="openFavouriteModal(containerContent, favourite, favourite.interaction)">
              </i>
              <span class="text-uppercase font-xs">{{ft("recipe.add_to_favourites")}}</span>
            </div>
            <div class="recipe__info__title col-12 py-3 pl-0 border-bottom">
              <div class="recipe__info__category-class pb-1">
                <span v-if="content.course && getContent(content.course).title" class="font-xs text-uppercase">{{getContent(content.course).title}}</span>
              </div>
              <h1 class="h3">{{content.title}}</h1>
            </div>
            <component
              v-if="owner"
              :is="owner.url ? 'a' : 'div'"
              :href="owner.url ? owner.url.url : ''"
              :target="getTarget(owner.url)"
              class="recipe__info__owner py-4 d-flex align-items-center pl-0 col-12 border-bottom deco-none link-black"
            >
              <div
                v-if="owner.avatar"
                class="owner-avatar bg-cover-center"
                :style="{'background-image': getBackgroundUrl(owner.avatar.url)}"
              ></div>
              <span class="pl-2 font-sm">By <b>{{owner.username}}</b></span>
            </component>
            <div v-if="content.info" class="recipe__info__details col-12 py-4 text-uppercase flex-wrap font-xs pl-0 d-flex align-items-center">
              <div v-if="difficulty" class="recipe__info-detail pr-4">{{ft("recipe.difficulty")}}: <span :class="textColorClass">{{difficulty}}</span></div>
              <div v-if="expence" class="recipe__info-detail pr-4">{{ft("recipe.cost")}}: <span :class="textColorClass">{{expence}}</span></div>
              <div v-if="content.info.quantity" class="recipe__info-detail pr-4">{{ft("recipe.servings")}}:
                <span :class="textColorClass">{{content.info.quantity}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="recipe__main-content align-self-start my-4 col-12 col-lg-8 col-xl-7 pl-lg-0 order-4 order-lg-3">
          <div class="row">
            <div v-if="content.time" class="recipe-times col-12">
              <div class="bg-kenwood-light-grey font-xs text-uppercase d-flex flex-column flex-sm-row">
                <div class="w-30 w-sm-100 pl-3 pl-sm-0 py-2">
                  <div class="text-sm-center border-right border-kenwood-dark-grey py-0 py-sm-2">
                    {{ ft("recipe.preparation_time", { time: getDurationTime(content.time.preparation_time) }) }}
                  </div>
                </div>
                <div class="w-24 w-sm-100 pl-3 pl-sm-0 py-2">
                  <div class="py-0 py-sm-2 text-sm-center border-right border-kenwood-dark-grey">
                    {{ ft("recipe.cooking_time", { time: getDurationTime(content.time.cooking_time) }) }}
                  </div>
                </div>
                <div class="w-22 w-sm-100 pl-3 pl-sm-0 py-2 py-sm-3 text-sm-center">
                  {{ ft("recipe.resting_time", { time: getDurationTime(content.time.resting_time) }) }}
                </div>
                <div class="w-24  w-sm-100 pl-3 pl-sm-0 py-2 py-sm-3 text-white text-sm-center" :class="backgroundColorClass">
                  {{ ft("recipe.total_time", { time: totalTime }) }}
                </div>
              </div>
            </div>
            <div class="introduction col-12 pt-4" v-if="content.description">
              <h4 class="pb-2">{{ft("recipe.introduction")}}</h4>
              <p class="pt-2 pb-0 mb-0" v-html="content.description"></p>
              <div v-if="specialOccasions" class="special-occasions d-flex pt-2 font-xs flex-wrap">
                <div v-for="(specialOccasion, index) in specialOccasions" class="pr-2 pb-2" :key="`occasion-${index}`">
                  <a :href="specialOccasion.slug" class="btn rounded-pill btn-filter text-capitalize px-4 py-1">{{specialOccasion.title}}</a>
                </div>
              </div>
            </div>
            <div class="equipment pt-3 col-12" v-if="accessories && accessories.length > 0">
              <h4 class="pb-3">{{ft("recipe.equipment")}}</h4>
              <div class="accessory-carousel" ref="accessory-carousel">
                <div class="accessory-carousel-item" v-for="(accessory, index) in accessories" :key="`carousel-slide-${index}`">
                  <div class="ar-1by1 position-relative border" :class="borderColorClass">
                    <a :href="accessory.url ? accessory.url.url : 'javascript:void(0)'" :target="getTarget(accessory.url)">
                      <div v-if="accessory.thumbnail" class="w-100 h-100 position-absolute bg-cover-center" :style="{'background-image': getBackgroundUrl(accessory.thumbnail.url)}">
                        <div class="accessory-shopping-icon" v-if="accessory.url">
                          <i class="far fa-shopping-cart"></i>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="mt-2 pt-1 accessory-title">{{accessory.title}}</div>
                  <a class="accessory-title text-red-cabbage text-uppercase d-flex align-items-center deco-none" :href="accessory.slug" v-if="accessory.slug">
                    {{ft("recipe.filter_recipes")}} <i class="fal fa-lg fa-angle-right ml-1"></i>
                  </a>
                </div>
              </div>
            </div>
            <div v-if="content.steps" class="procedure pt-4 col-12" ref="procedure">
              <h4 class="pb-3">{{ft("recipe.procedure")}}</h4>
              <div v-for="(step, i) in content.steps" class="entire-step pb-4" :key="`step-${i}`">
                <div class="row">
                  <div class="col-auto col-md-1 d-flex pr-2">
                    <div class="step-counter text-white d-flex rounded-circle align-items-center justify-content-center" :class="backgroundColorClass">
                      {{i+1}}
                    </div>
                  </div>
                  <template v-if="step.title">
                    <div class="col col-lg-11 d-flex align-items-center pl-2 step-title">{{step.title}}</div>
                    <div class="col-1 d-lg-flex pr-2 d-none"><div class="step-counter-mock-spacer"></div></div>
                  </template>
                  <div class="col-12 col-lg-11 d-flex flex-column align-items-begin pl-lg-2 pt-2">
                    <div v-html="step.description"></div>
                    <a v-if="step.image" class="recipe-img bg-cover-center magnific-popup" :href="step.image.url" :style="{'background-image': getBackgroundUrl(step.image.url)}" ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-5 order-3 order-lg-4">
          <ingredients-box
            v-for="(box, index) in ingredientsBoxes"
            :key="`ingredient-box-${index}`"
            :content="content"
            :containerContent="containerContent"
            :title="getIngredintsTitle(box.title)"
            :ingredients="calcIngedients(box.ingredients)"
            :allergens="getTagsInfoFromContents(box.allergens)"
            :name="`ingredient-box-${index}`"
            :color="color"
            >
          </ingredients-box>
          <div class="share-interactions d-flex px-4 pt-4 pb-4">
            <div class="d-flex align-items-center font-sm pr-3">{{ft("recipe.share_recipe")}}:</div>
            <share-icons v-if="share" :content="content" :containerContent="containerContent"></share-icons>
          </div>
        </div>
      </div>
    </div>
    <div v-if="owner && content.preparation_advice" class="container-fluid recipe_quote text-white" :class="backgroundColorClass">
      <div class="row mx-0 py-4 justify-content-center">
        <div class="col-12 col-md-8 d-flex flex-column justify-content-center align-items-center py-2">
          <component
            v-if="owner.avatar"
            :is="owner.url ? 'a' : 'div'"
            :href="owner.url ? owner.url.url : null"
            :target="getTarget(owner.url)"
            class="quote__avatar rounded-circle mt-1 mb-3 bg-cover-center"
            :style="{'background-image': getBackgroundUrl(owner.avatar.url)}"
          ></component>
          <div class="text-uppercase pb-3 font-xs">{{owner.first_name}} {{owner.last_name}}</div>
          <div class="text-uppercase text-center pb-4 h3">{{ft("recipe.chef_advice")}}</div>
          <div class="h4 d-block text-center quote__description mb-4" v-if="content.preparation_advice" v-html="content.preparation_advice"></div>
        </div>
      </div>
    </div>
    <div v-if="content.extra_details" class="container-fluid bg-white py-4">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 py-3">
            <p class="h2">{{ft("recipe.extra_details")}}</p>
          </div>
          <div class="col-12 py-4">
            <div v-html="content.extra_details"></div>
          </div>
          <div v-if="share" class="col-12 py-3">
            <div class="share-interactions d-flex">
              <div class="d-flex align-items-center font-sm pr-3">{{ft("recipe.share_recipe")}}:</div>
              <share-icons :content="content" :containerContent="containerContent"></share-icons>
            </div>
          </div>
        </div>
      </div>
    </div>
    <component :is="stripe.layout" :content="stripe" v-for="stripe in content.stripes" :key="stripe.$id" :opt-container-content="containerContent"></component>
    <stripe-related-recipes
      :content="content"
      :tagExtraField="!!content.related_content_recipe_tag ? 'related_content_recipe_tag' : 'course'"
      :optionalRelatedContentNames="content.related_content_recipes"
      :optionalViewMoreLink="(content.related_view_more_link || {}).url"
    ></stripe-related-recipes>
    <stripe-related-articles
      v-if="!!content.related_content_article_tag || !!content.related_content_articles"
      :content="content"
      tagExtraField="related_content_article_tag"
      :optionalRelatedContentNames="content.related_content_articles"
    ></stripe-related-articles>
  </div>
</template>

<style lang="scss">
[recipe] {
  --recipe-color: $red-cabbage;

  .recipe__main-image {
    .main-img {
      width: 100%;
      padding-bottom: 57.6%;
      position: relative;
      overflow: hidden;
    }

    .recipe-main-image {
      object-fit: cover;
      max-width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .recipe__info__favourite {

    i {
      &:hover {
        color: var(--recipe-color);
        cursor: pointer;
      }

    }

  }

  .recipe__info {
    .recipe__info__owner {
      .owner-avatar {
        height: 42px;
        width: 42px;
        border-radius: 50%;
      }
    }
  }

  .recipe__main-content {
    .step-counter, .step-counter-mock-spacer {
      width: 42px;
      height: 42px;
      font-family: $bressay-font;
      font-size: 1.75rem;
    }

    .recipe-img {
      width: 100%;
      padding-bottom: 52.5%;
      transition: opacity 0.35s;
      &:hover {
        opacity: 0.92;
      }
    }

    .accessory-carousel-item {
      width: 23.5%;
      margin-right: 1.5%;
    }

    .accessory-shopping-icon {
      width: 40px;
      height: 40px;
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: $red-cabbage;
      color: $white;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.3rem;
    }

    .accessory-title {
      font-size: .875rem;
    }

    .special-occasion__item {
      border-radius: 1rem;
      color: black;
    }

    .step-title {
      font-family: $bressay-font;
      font-size: 1.25rem;
    }

  }

  .recipe_quote {

    .h4 {
      font-size: 1.625rem !important;
    }

    .quote__description {
      font-family: "Bressay";
    }

    .quote__avatar {
      width: 6rem;
      height: 6rem;
    }

  }

  .btn-filter {
    color: $black;
    border-color: $black;
    font-size: .75rem;

    @include hover {
      color: $white !important;
      border-color: transparent;
      background-color: var(--recipe-color);
    }
  }

  .recipe__info-detail {
    &:last-child {
      padding-top: 0;
    }
  }

  @include media-breakpoint-down(xl) {}

  @include media-breakpoint-down(lg) {}

  @include media-breakpoint-down(md) {}

  @include media-breakpoint-down(sm) {
    .recipe__main-content {
      .accessory-carousel-item {
        width: 38.5%;
        margin-right: 1.5%;
      }
    }
  }

  @include media-breakpoint-down(xs) {
    .recipe__info-detail {
      width: 50%;
      &:last-child {
        padding-top: 1rem;
      }
    }
    .recipe__main-content {
      .recipe-times {
        .border-right {
          border-right: none !important;
        }
      }
    }
  }

}
</style>
